import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { QUESTIONS } from "./fuel-system-helper";
import { isSelected } from "./air-system-helper";

const CustomCheckBox = ({ label, checked, onChange }) => {
  return (
    <FormControlLabel
      control={<Checkbox checked={checked} onChange={onChange} />}
      label={label}
    />
  );
};

const FuelSystem = ({ checklistDetails, setChecklistDetails }) => {
  const [details, setDetails] = useState(
    checklistDetails?.checkList?.fuelSystem || {}
  );

  const onChange = (question, option) => {
    const { apiOptionKey } = option;
    const updatedDetails = {
      ...details,
      [apiOptionKey]: !details[apiOptionKey],
    };
    setDetails(updatedDetails);
  };

  const onTextChange = (option, text) => {
    const { apiOptionKey } = option;
    const updatedDetails = {
      ...details,
      [apiOptionKey]: text,
    };
    setDetails(updatedDetails);
  };

  useEffect(() => {
    setChecklistDetails((prevVal) => ({
      ...prevVal,
      checkList: {
        ...checklistDetails?.checkList,
        fuelSystem: details,
      },
    }));
  }, [details]);

  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="h6" gutterBottom>
        Fuel System
      </Typography>

      {QUESTIONS?.map((question) => (
        <Box key={question.label} sx={{ mb: 3, px: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            {question.label}
          </Typography>

          <Box display="flex" flexWrap="wrap" gap={2}>
            {question.type === "INPUT" && (
              <TextField
                fullWidth
                variant="outlined"
                placeholder={question.label}
                type={question.keyboardType || "text"}
                value={details[question.apiKey] || ""}
                onChange={(e) =>
                  setDetails({ ...details, [question.apiKey]: e.target.value })
                }
              />
            )}

            {question.options.map((option) => {
              if (option.type === "INPUT") {
                return (
                  <TextField
                    key={option.label}
                    label={option.label}
                    variant="outlined"
                    type={option.keyboardType || "text"}
                    value={details[option.apiOptionKey] || ""}
                    onChange={(e) => onTextChange(option, e.target.value)}
                  />
                );
              } else {
                return (
                  <CustomCheckBox
                    key={option.label}
                    label={option.label}
                    checked={isSelected(details, question, option)}
                    onChange={() => onChange(question, option)}
                  />
                );
              }
            })}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default FuelSystem;
